module.exports = __webpack_public_path__ + "static/resume-b04062c2431c52cc180cd30bc445aebf.jpg";